import { DataLossService } from '@shared/services';
import { Injectable, inject } from '@angular/core';
import {
  ApiServiceService,
  AuthService,
  ApplicationInsightsService
} from '@oneeducation/app-core';
import { BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';
import { USER_ENDPOINT } from '@shared/properties';
import { userModel, School } from '@usermanagement/models';

@Injectable({
  providedIn: 'root'
})
export class UserRoleService {
  private readonly apiservice = inject(ApiServiceService);
  private readonly authService = inject(AuthService);
  private readonly appInsightsService = inject(ApplicationInsightsService);
  private readonly router = inject(Router);
  private readonly dataLossService = inject(DataLossService);

  LAName: string;
  LaID: number;
  UserId: string;
  userType: string;
  customErrorMessage: string;
  LaWeeks: number;
  SchoolWeeks: number;
  schoolUserContextId: number;
  User: userModel;
  product: string;
  private userData = new BehaviorSubject(false);
  public userInfoReceived = this.userData.asObservable();

  private schoolContext = new BehaviorSubject(false);
  public schoolContextChanged = this.schoolContext.asObservable();

  constructor() {
    this.authService.isAuthenticated.subscribe((data) => {
      if (data === true) {
        this.UserId = this.apiservice.userId = this.authService.loggedInUserId;
        this.getUserType();
      }
    });
  }

  get isLocalAuthorityUser(): boolean {
    return this.userType === 'LA';
  }

  get isSchoolAdmin() {
    return this.userType === 'School';
  }

  private getUserType() {
    // API call to get user type

    this.apiservice
      .get<userModel>(
        USER_ENDPOINT.GetUserByUserId.replace('{userId}', this.UserId),
        ''
      )
      .subscribe({
        next: (x: any) => {
          this.User = x.user[0];
          this.userType = x.user[0].userType;
          this.LaID = x.user[0].laId;
          this.LAName = x.user[0].laName;
          this.product = x.user[0].product.name;

          // log the MFA option selected by user to app insights
          this.logSelectedMFADetails();

          if (this.isLocalAuthorityUser === true) {
            this.apiservice.laId = this.LaID;
            this.userData.next(true);
            this.router.navigateByUrl('/users/manageusers');
          } else if (this.isSchoolAdmin === true) {
            if (x.user[0].schools.length > 0) {
              // Add dfe number property for the schools in User Object
              this.User.schools.forEach((school: School) => {
                school.dfeNumber = school.laId + school.schoolNumber;
              });
              x.user[0].schools.sort((a, b) =>
                a.schoolName
                  .toLowerCase()
                  .localeCompare(b.schoolName.toLowerCase())
              );
            }

            for (let i = 0; i <= x.user[0].schools.length; i++) {
              this.schoolUserContextId = x.user[0].schools[i].schoolId;
              break;
            }
            this.apiservice.laId = this.LaID;
            this.userData.next(true);
            this.router.navigateByUrl('/exclusions/pupildetails');
          }
        },
        error: (x: any) => {
          if (x.status === 401) {
            alert('User is not authorized');
            this.authService.logout();
          }
          if (x.status === 404) {
            alert('User is Inactive');
            this.authService.logout();
          }
        }
      });
  }

  setSchoolContext(schoolId) {
    this.schoolUserContextId = schoolId;
    this.schoolContext.next(true);
  }

  private logSelectedMFADetails() {
    // check if localstorage already have a bool set
    if (!(localStorage.getItem('IsMFADetailsLogged') === 'true')) {
      // assign properties which will be displayed on dashboard
      const properties = [
        {
          MFAMethod: this.authService.getSelectedMFAMethod(),
          Product: this.User.product.name,
          Email: this.User.email,
          UserType: this.User.userType,
          UserId: this.User.userId
        }
      ];

      // log metric inside app insights
      for (const element of properties)
        this.appInsightsService.logMetric('MFAOptionSelected', 1, element);

      // set local storage to avoid repetative logs
      localStorage.setItem('IsMFADetailsLogged', 'true');
    }
  }

  logout() {
    if (this.dataLossService.checkForUnsavedChanges()) {
      this.authService.logout();
    }
  }
}
